export default {"src":"/stays/_next/static/media/support.35ab2b58.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};